// extracted by mini-css-extract-plugin
export var active = "_2x-2";
export var container = "_2x-0";
export var expired = "_2x-3";
export var hasStatus = "_2x-4";
export var statusChip = "_2x-1";